import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const BookIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M1 2.5H5.2C5.94261 2.5 6.6548 2.78095 7.1799 3.28105C7.705 3.78115 8 4.45942 8 5.16667V14.5C8 13.9696 7.77875 13.4609 7.38492 13.0858C6.9911 12.7107 6.45695 12.5 5.9 12.5H1V2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 2.5H10.8C10.0574 2.5 9.3452 2.78095 8.8201 3.28105C8.295 3.78115 8 4.45942 8 5.16667V14.5C8 13.9696 8.22125 13.4609 8.61508 13.0858C9.0089 12.7107 9.54305 12.5 10.1 12.5H15V2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
